import {
  CANCELLATION_REASON_KEYS,
  cancellationReasonI18nKey,
} from '../langs/cancellationReasons'

const KNOWN_REASONS = new Set<string>(CANCELLATION_REASON_KEYS)

/**
 * Renders a cancellation `reason` from `/payment/cancellations/` as a label.
 *
 * Three cases, in order. A reason we know is translated, so the picker and
 * the super admin table read the same words in the reader's own language. A
 * reason recorded before the picker shipped arrives as `''` alongside an
 * empty `reason_label`, and is shown the way the backend's own emails put it.
 * A reason the backend added before we hardcoded it falls back to the
 * `reason_label` it rendered - English in a Greek table, but readable, which
 * beats a raw `seasonal_pause` - and to the key itself if there is no label.
 *
 * Which case applies is decided by `CANCELLATION_REASON_KEYS`, not by whether
 * `t` handed back the key it was given: a known reason with a missing
 * translation should be fixed in `src/langs`, not quietly papered over with
 * whatever language the API happens to render labels in.
 */
export const formatCancellationReason = (
  t: (key: string) => string,
  reason?: string | null,
  reasonLabel?: string | null,
): string => {
  const key = (reason ?? '').trim()
  if (!key) return t('notGiven')
  if (KNOWN_REASONS.has(key)) return t(cancellationReasonI18nKey(key))

  return reasonLabel?.trim() || key
}
